import React, { useRef, useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { SmartImage } from "./SmartImage";

export const BeforeAfterSlider = ({ before, after, beforeLabel = "VOOR", afterLabel = "NA", aspect = "16/10", beforeAlt = "Voor renovatie", afterAlt = "Na renovatie", eager = false }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const updateFromX = (clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    setPos((x / rect.width) * 100);
  };

  const onPointerDown = (e) => {
    dragging.current = true;
    containerRef.current?.setPointerCapture?.(e.pointerId);
    updateFromX(e.clientX);
  };
  const onPointerMove = (e) => { if (dragging.current) updateFromX(e.clientX); };
  const onPointerUp = () => { dragging.current = false; };

  return (
    <div
      ref={containerRef}
      className="ba-wrapper w-full bg-koning-surface"
      style={{ aspectRatio: aspect, touchAction: "pan-y", userSelect: "none" }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      onDragStart={(e) => e.preventDefault()}
      data-testid="before-after-slider"
      role="slider"
      aria-label="Vergelijk vóór en ná"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pos)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "ArrowLeft") setPos((v) => Math.max(0, v - 5));
        if (e.key === "ArrowRight") setPos((v) => Math.min(100, v + 5));
      }}
    >
      <SmartImage src={before} alt={beforeAlt} sizes="100vw" eager={eager} className="absolute inset-0 w-full h-full object-cover" />
      <div className="ba-after" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
        <SmartImage src={after} alt={afterAlt} sizes="100vw" eager={eager} className="w-full h-full object-cover" />
      </div>
      <div className="ba-handle" style={{ left: `${pos}%` }}>
        <div className="ba-knob"><ArrowLeftRight size={18} /></div>
      </div>
      <div className="ba-label" style={{ left: 14 }}>{beforeLabel}</div>
      <div className="ba-label" style={{ right: 14 }}>{afterLabel}</div>
    </div>
  );
};
